var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31.5,
    width: 31,
    height: 31,
    rx: 3.5,
    transform: "rotate(-180 32 31.5)",
    stroke: "#423A38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7L13.6132 12L19.3868 12L16.5 7ZM17 25L17 11.5L16 11.5L16 25L17 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonUp);
export default __webpack_public_path__ + "static/media/button-up.31971091e0a73d5565891b9396fbe084.svg";
export { ForwardRef as ReactComponent };